// extracted by mini-css-extract-plugin
export default {"root":"StudioDateInput_root__CAbdn"};